import { useMemo } from "react";
import { DataForm } from "@introist/react-foundation/v2";
import { WorkflowStep } from "services/api/WorkflowApi";

// Editors
import { EmailTaskEditorV2, SlackTaskEditor } from "../../TaskStepEditorV2";
import { SlackStepEditorV2 } from "../../SlackStepEditorV2";
import { EventStepEditor } from "../../EventStepEditor";
import { WebhookStepEditorV2 } from "../../WebhookStepEditorV2";
import { WorkflowTriggerStepEditorV2 } from "../../WorkflowTriggerStepEditorV2";

import { InviteStepEditor } from "../../InviteStepEditor";
import { StepTypesV2 } from "services/rpc/RpcProvider";
import { FreshserviceOnboardingEditor } from "../../FreshserviceOnboarding";
import { SlackQuestionEditor } from "../../SlackQuestionEditor";
import { EmployeeSelectEditor } from "../../EmployeeSelectEditor";
import { WorkflowTriggerStepEditorV3 } from "../../WorkflowTriggerStepEditorV3";

type UseStepEditorArgs = {
  form: DataForm<WorkflowStep>;
  formPrefix: string;
};

export const useWorkflowStepEditor = ({ form, formPrefix }: UseStepEditorArgs) => {
  const editor = useMemo(() => {
    const { Enum } = StepTypesV2;
    switch (form.data.stepType) {
      case Enum.emailtask:
        return <EmailTaskEditorV2 form={form} />;
      case Enum.enroll:
        return <WorkflowTriggerStepEditorV2 form={form} formPrefix={formPrefix} />;
      case Enum.event:
        return <EventStepEditor form={form} formPrefix={formPrefix} />;
      case Enum.invite:
        return <InviteStepEditor form={form} formPrefix={formPrefix} />;
      case Enum.slack:
        return <SlackStepEditorV2 form={form} formPrefix={formPrefix} />;
      case Enum.slacktask:
        return <SlackTaskEditor form={form} formPrefix={formPrefix} />;
      case Enum.webhook:
        return <WebhookStepEditorV2 form={form} formPrefix={formPrefix} />;
      case Enum.freshserviceonboarding:
        return <FreshserviceOnboardingEditor form={form} formPrefix={formPrefix} />;
      case Enum.slackquestion:
        return <SlackQuestionEditor form={form} formPrefix={formPrefix} />;
      case Enum.employeeselect:
        return <EmployeeSelectEditor form={form} formPrefix={formPrefix} />;
      case Enum.workflowtrigger:
        return <WorkflowTriggerStepEditorV3 form={form} formPrefix={formPrefix} />;
      default:
        return null;
    }
  }, [form, formPrefix]);

  return editor;
};
